import React from "react";
import { useEffect, useState } from "react";
import FormComponent from "./form-component/form.component";
import update from "immutability-helper";
import { compose } from "recompose";
import { connect } from "react-redux";
import getDateTimeString from "op/utils/getDateTimeString";
import { hot } from "react-hot-loader";
import { withAxios } from 'op/components/auth';
import { useHistory } from "react-router";

const FormContainer = ({
  user,
  item,
  axios
}) => {
  const history = useHistory();
  const [report, setReport] = useState({
    signatures: {
      EmpSig: undefined,
    }
  });

  const invokeChange = (change) => setReport(update(report, change));

  const [form, setForm] = useState({
    asM_User_ID: user.id,
    asM_Item_ID: item.ASM_Item_ID,
    asM_FormTypeID: null,
    asM_ItemReportFormDate: getDateTimeString(new Date()),
    asM_ItemReportFormRemarks: "",
    asM_ItemReportOverallStatus: null,
    asM_ItemReportFormAlert: false,
    asM_ItemReportFormSig: "",
    asM_ItemReportFormGenericName:"",
    isFormTypeStatus: null,
    reportFormLines: []
  });

  useEffect(() => {
    if (report.signatures.EmpSig)
      setForm((prev) => {
        const newForm = { ...prev };

        newForm.asM_ItemReportFormSig = report.signatures.EmpSig.replace('data:image/png;base64,', '');

        return newForm;
      });
  }, [report]);

  const hasNoAnswers = () =>{
    return form.reportFormLines.some(line => !line.asM_ItemReportFormLineStatus)
  }

  const submit = () => {
    axios.post('/api/Forms/saveFormReport', form)
      .then(res => {
        history.push(`/forms/${item.ASM_Item_ID}/records`);
      })
      .catch(err => {
        console.log(err);
      });
  }

  return (
    <FormComponent
      user={user}
      report={report}
      invokeChange={invokeChange}
      form={form}
      setForm={setForm}
      onSubmit={submit}
      hasNoAnswers = {hasNoAnswers()}
      overallStatus = {form.asM_ItemReportOverallStatus}
    />
  );
}

export default compose(
  hot(module),
  connect(
    ({ auth, forms }, { match }) => ({
      user: auth.user,
      item: forms.loaded.find(item => item.ASM_Item_ID.toString() == match.params.item_id),
    }),
  ),
  withAxios,
)(FormContainer);
